module.exports = __webpack_public_path__ + "static/media/connectors_fiber.1d44f06e.jpg";